import { queryOptions } from '@tanstack/react-query';
import { authService } from './services/authService';

export const authQueries = {
  all: () => ['auth'] as const,
  me: () =>
    queryOptions({
      queryKey: [...authQueries.all(), 'me'] as const,
      queryFn: () => authService.me(),
      staleTime: 10 * 60 * 1000,
      retry: false,
    }),
};
